import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ConfirmationDaybook = ({
  setShowCloseModal,
  showCloseModal,
  performDayToggle,
  orderData,
  isOpen,
  toggle,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false}>
      <ModalHeader toggle={toggle} className="border-bottom-0">
        <span className="text-warning">
          <i className="ri-alert-line me-2"></i>
          Confirm Day Close
        </span>
      </ModalHeader>
      <ModalBody>
        <div className="text-center">
          <div className="mb-3">
            <i
              className="ri-error-warning-line text-warning"
              style={{ fontSize: "3rem" }}
            ></i>
          </div>
          <h6 className="mb-3">
            You have {orderData.length} order(s) for today.
          </h6>
          <p className="text-muted mb-0">
            Are you sure you want to close the day? This action will finalize
            all transactions for today.
          </p>
        </div>
      </ModalBody>
      <ModalFooter className="border-top-0 justify-content-center">
        <Button color="secondary" onClick={toggle} className="me-2">
          Cancel
        </Button>
        <Button
          color="danger"
          onClick={() => {
            toggle();
            performDayToggle(false);
          }}
        >
          <i className="ri-check-line me-1"></i>
          Yes, Close Day
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationDaybook;
